import Configuration from '@/src/components/Configuration/Configuration';
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router';
import { Button } from 'src/components/Antd';
import FieldModal from 'src/components/FieldModal';
import {
  EnumFieldType,
  typeDisplayName,
} from 'src/components/FieldModal/config';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableTip';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';

import {
  FieldTypeKeyMapping,
  FiledNameKeyMapping,
} from '@/src/pages/CustomerDatabaseConfig/config';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const InformationSelection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid: salesChannelUuid }: any = useParams();

  const {
    //data = [],
    onChange,
    setHasModified, //需要删除

    error,
    tip,
    id,
    isOptOptional,
    disableEdit,
  } = props;
  const data = get(props, 'data', []) || [];
  const fields = get(props, 'fields', []) || [];
  const { emptyError, setEmptyError } = error || {};

  const [visible, setVisible] = React.useState(false);
  const [currentData, setCurrentData] = React.useState(null);
  const handleOnClose = () => {
    setVisible(false);
    setCurrentData(null);
  };

  const _setHasModified = () => {
    if (setHasModified) setHasModified(true);
  };

  const handleOnFieldChange = (newData) => {
    _setHasModified();
    if (setEmptyError) setEmptyError(false);
    const _data = [...(data || [])];
    const { field, required, isAddNew, index, dateOfBirthFields, otpRequired } =
      newData;
    //console.log('newData', newData);
    const _f: any = { field, required, dateOfBirthFields };
    if (isOptOptional) {
      _f.otpRequired = otpRequired;
    }
    if (isAddNew) {
      _data.push(_f);
    } else {
      _data.splice(index, 1, _f);
    }
    if (onChange) {
      onChange(_data);
    }
    handleOnClose();
  };

  const handleOnFieldSort = (e) => {
    _setHasModified();
    if (onChange) {
      onChange(e);
    }
  };

  const handleOnAdd = () => {
    // const sD = data[index];
    setCurrentData({});
    setVisible(true);
  };

  const handleOnEdit = (index) => {
    const sD = data[index];
    const _sD = { ...(sD || {}), index };
    setCurrentData(_sD);
    setVisible(true);
  };

  const handleOnDelete = (index) => {
    _setHasModified();
    const _data = [...(data || [])];
    _data.splice(index, 1);
    if (onChange) {
      onChange(_data);
    }
  };
  //[{value:+0PN label:""}]

  const availableFields = React.useMemo(() => {
    const currentSelectUuid = get(currentData, 'field.uuid');

    const hasMobile = data.find((i) => {
      const fieldType = get(i, 'field.fieldType');
      return (
        fieldType === EnumFieldType.MobileNumber ||
        fieldType === EnumFieldType.AreaCode
      );
    });

    const hasAreaAndMobile = data.find((i) => {
      const fieldType = get(i, 'field.fieldType');
      return fieldType === EnumFieldType.AreaCodeMobileNumber;
    });

    const hasSeperatedNames = data.find((i) => {
      const fieldType = get(i, 'field.fieldType');
      return (
        fieldType === EnumFieldType.FirstName ||
        fieldType === EnumFieldType.LastName
      );
    });

    const hasFullName = data.find((i) => {
      const fieldType = get(i, 'field.fieldType');
      return fieldType === EnumFieldType.FullName;
    });

    const fieldsUuid = data.map((i) => {
      const uuid = get(i, 'field.uuid');
      return uuid;
    });

    const _uuids = fieldsUuid.filter((i) => i !== currentSelectUuid); //应该被过滤掉的

    const _fields = fields.reduce((pre, now) => {
      const uuid = get(now, 'uuid');
      const fieldType = get(now, 'fieldType');
      const isVac = !_uuids.includes(uuid);
      if (isVac) {
        if (fieldType === EnumFieldType.FullName && hasSeperatedNames) {
          return [...pre];
        }
        if (
          (fieldType === EnumFieldType.FirstName ||
            fieldType === EnumFieldType.LastName) &&
          hasFullName
        ) {
          return [...pre];
        }
        if (fieldType === EnumFieldType.AreaCodeMobileNumber && hasMobile) {
          return [...pre];
        }
        if (
          (fieldType === EnumFieldType.MobileNumber ||
            fieldType === EnumFieldType.AreaCode) &&
          hasAreaAndMobile
        ) {
          return [...pre];
        }

        return [...pre, now];
      } else {
        return pre;
      }
    }, []);

    return _fields;
  }, [fields, currentData, data]);

  return (
    <React.Fragment>
      {visible && (
        <FieldModal
          availableFields={availableFields}
          visible={visible}
          onOk={handleOnFieldChange}
          onCancel={handleOnClose}
          isOptOptional={isOptOptional}
          unChangeableFields={[]}
          {...(currentData || {})}
        />
      )}
      <Tip>{tip}</Tip>
      <DroppableTable
        type={'test'}
        //rowSelection={row}
        error={
          emptyError ? getI18n('general.selectatleastoneinformation') : null
        }
        pagination={false}
        rowKey={(record) => {
          const uuid = get(record, 'field.uuid');
          return uuid;
        }}
        dataSource={data || []}
        columns={col(handleOnEdit, handleOnDelete, disableEdit, { getI18n })}
        id={id}
        onTableChange={handleOnFieldSort}
        hideAllDragHandlers={disableEdit}
        // rowDeleteFunc={deleteProduct}
      />
      <Button
        disabled={(availableFields || []).length === 0 || disableEdit}
        onClick={handleOnAdd}
        type='primary'
        className={css.addNew}>
        {getI18n('general.selectInformationfield')}
      </Button>
      <div className={css.configContainer}>
        <Configuration
          configStart={getI18n('general.gotothetranslation')}
          configLink={getI18n('general.customer.language')}
          linkTo={`/salesChannel/setting/language/${salesChannelUuid}`}
          configEnd={getI18n('general.totranslatethefield')}
        />
      </div>
    </React.Fragment>
  );
};
export default InformationSelection;

const col = (onEdit, onDelete, disableEdit, { getI18n }) => {
  return [
    {
      title: getI18n('general.customerinformationfield'),
      key: 'InfoField',
      default: true,
      childGenerate: (url, record) => {
        const { field } = record;
        const { name } = field;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={getI18n(FiledNameKeyMapping[name])}>
              {getI18n(FiledNameKeyMapping[name])}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      minWidth: 290,
    },
    {
      title: getI18n('general.fieldType'),
      key: 'type',
      default: true,
      childGenerate: (url, record) => {
        const { field } = record;
        const { type } = field;
        const typeName = typeDisplayName[type];
        return (
          <NoWrapContainer>
            <GlobalTooltip title={getI18n(FieldTypeKeyMapping[typeName])}>
              {getI18n(FieldTypeKeyMapping[typeName])}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      minWidth: 180,
    },
    {
      title: getI18n('general.requiredOptionalField'),
      key: 'req',
      default: true,
      childGenerate: (url, record) => {
        const { required } = record;
        const name = required
          ? getI18n('general.required')
          : getI18n('general.optional');
        return (
          <NoWrapContainer>
            <GlobalTooltip title={name}>{name}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      width: 180,
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          key: 'Actions',
          default: true,
          childGenerate: (url, record, index) => {
            return (
              <div className={css.tableLastContainer}>
                <div
                  className={css.edit}
                  onClick={() => {
                    onEdit(index);
                  }}>
                  {getI18n('general.edit')}
                </div>
                <div
                  className={css.delete}
                  onClick={() => {
                    onDelete(index);
                  }}>
                  {getI18n('general.delete')}
                </div>
              </div>
            );
          },
          width: 160,
        },
  ];
};
